import {inject, Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {ModalService} from './modal.service';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  private readonly modal = inject(ModalService);
  isProgress: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  counter = 0;
  navigating = false;

  constructor() {
  }

  show(fromNavigation = false) {
    this.setProgress(true, fromNavigation);
  }

  hide(fromNavigation = false) {
    this.setProgress(false, fromNavigation);
  }

  setProgress(visible: boolean, fromNavigation = false) {
    if (visible) {
      if (fromNavigation) {
        this.navigating = true;
      } else {
        this.counter++;
      }
    } else {
      if (fromNavigation) {
        this.navigating = false;
      } else {
        this.counter--;
      }
    }
    if (this.counter < 0) {
      this.counter = 0;
    }
    this.isProgress.next(this.counter !== 0 || this.navigating);
  }

  async runWithProgress(fn: () => Promise<any>, finallyFn?: () => void) {
    this.show();
    try {
      await fn();
    } catch (e) {
      this.modal.showError(e);
      throw e;
    } finally {
      this.hide();
      finallyFn?.();
    }
  }
}
